import { useSelector } from 'react-redux';
import { strictEquals } from '../../language/module';
import { AppState } from './appState';


/**
 * This hook uses the given selector function to pull something out of app state. Uses strict equality to determine when
 * to re-run. This hook exists for two reasons:
 *   1. The Redux useSelector hook needs a lot of boiler (it can't even do proper type inference)
 *   1. This hook decouples Redux from app logic even more (not the main purpose, but it's a nice decoupling point)
 * @param selector - Function that pulls your value out of app state
 */
export const useAppState = <T>(
  selector: (state: AppState) => T,
): T => useSelector<AppState, T>(selector, strictEquals);
